// src/Components/Promo/PortfolioRegions.js

import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

export default function PortfolioRegions({
  selectedItem,
  activeRegions,
  onToggle,
  onToggleAll,
}) {
  const currentIds = selectedItem?.regionIds || [];

  const allSelected =
    activeRegions.length > 0 && activeRegions.every((r) => currentIds.includes(r.id));
  const indeterminate = currentIds.length > 0 && currentIds.length < activeRegions.length;

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* AMENDED: Locked height to 40px to match table header */}
      <Box
        sx={{
          px: 2,
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}>
        <Typography variant='subtitle1' fontWeight='bold'>
          Select Regions
        </Typography>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          flexGrow: 1,
          width: '100%',
          borderTop: '2px solid #ff9800',
          borderBottom: 'none',
          borderRadius: 0,
          overflowY: 'auto',
        }}>
        <Table stickyHeader size='small'>
          <TableHead>
            {/* AMENDED: Locked height to 40px and removed vertical padding on th */}
            <TableRow
              sx={{
                height: '40px',
                '& th': {
                  backgroundColor: '#fff3e0',
                  fontWeight: 'bold',
                  borderBottom: '2px solid #ff9800',
                  py: 0,
                },
              }}>
              <TableCell padding='checkbox' sx={{ width: '50px' }}>
                <Checkbox
                  size='small'
                  checked={allSelected}
                  indeterminate={indeterminate}
                  disabled={!selectedItem}
                  onChange={(e) => onToggleAll(e.target.checked)}
                />
              </TableCell>
              <TableCell>Region Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {activeRegions.map((region) => {
              const isSelected = currentIds.includes(region.id);
              return (
                <TableRow
                  key={region.id}
                  hover
                  selected={isSelected}
                  onClick={() => onToggle(region.id)}
                  sx={{
                    cursor: selectedItem ? 'pointer' : 'default',
                    '&.Mui-selected': {
                      backgroundColor: 'transparent !important',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
                    },
                  }}>
                  <TableCell padding='checkbox'>
                    <Checkbox
                      size='small'
                      checked={isSelected}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => onToggle(region.id)}
                      disabled={!selectedItem}
                    />
                  </TableCell>
                  <TableCell>{region.name}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
